import { FlexRowSmallSpaced } from '@fox/layout';
import { ToggleButton as TB, ToggleButtonGroup as TBG, ToggleButtonGroupProps as TBGProps, ToggleButtonProps as TBProps } from '@mui/material';
import type { IconName } from '../icon';
import { Icon } from '../icon';

export const MuiToggleButton = (props: TBProps) => {
	return <TB {...props} />;
};

export const MuiToggleButtonGroup = (props: TBGProps) => {
	return <TBG {...props} />;
};

export type MuiToggleButtonProps = TBProps;
export type MuiToggleButtonGroupProps = TBGProps;

export function ModeSwitch<T extends string>(props: {
	opts: Record<T, string>;
	icons?: Partial<Record<T, IconName>>;
	value?: T;
	setValue: (a: T) => void;
	/** When enabled, prevents the value from being cleared when the user clicks the currently selected option without choosing another. */
	disableClearable?: boolean;

	fullWidth?: boolean;
	size?: TBProps['size'];
}) {
	return (
		<TBG
			value={props.value}
			onChange={(_e, v) => {
				if (v === null && props.disableClearable) return;
				props.setValue(v);
			}}
			exclusive
			fullWidth={props.fullWidth}
			sx={theme => ({
				backgroundColor: theme.palette.primary._states!.fill,
				border: `1px solid ${theme.palette.primary._states!.outlinedBorder}`,
				borderRadius: `${theme.shape['radius-md']}px`,
				overflow: 'hidden',
				'& .MuiToggleButtonGroup-grouped': {
					border: 'none !important',
					borderRadius: `${theme.shape['radius-md']}px !important`,
					color: theme.palette.text._fontColour.body,
					'&.Mui-selected': {
						backgroundColor: theme.palette.primary._states!.selected,
						color: theme.palette.text._fontColour.body
					},
					'&.Mui-selected:hover': {
						backgroundColor: theme.palette.primary._states!.selected
					}
				}
			})}
		>
			{Object.entries<string>(props.opts).map(([k, v]) => {
				const icon = props.icons?.[k as T];
				return (
					<TB key={`toggle-${k}`} size={props.size ?? 'small'} sx={{ textTransform: 'none' }} value={k}>
						{icon ? (
							<FlexRowSmallSpaced style={{ alignItems: 'center' }}>
								<Icon iconName={icon} fontSize="small" />
								{v}
							</FlexRowSmallSpaced>
						) : (
							v
						)}
					</TB>
				);
			})}
		</TBG>
	);
}
